var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [{ name: "mask-moeda", rawName: "v-mask-moeda" }],
    attrs: { autocomplete: "off", type: "text", id: _vm.id, name: _vm.name },
    domProps: { value: _vm.value },
    on: {
      blur: function ($event) {
        _vm.onBlur($event.target.value)
      },
      change: function ($event) {
        _vm.onChange($event.target.value)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }